import { gql } from '@grandvisionhq/graphql';

const baseProductFragment = gql`
  fragment BaseProductFragment on Product {
    slug
    brand
    productType
    name
    nameAllLocales {
      locale
      value
    }
    ... on ContactLensProduct {
      id
      productTypeDetails {
        replacementFrequencyAllLocales {
          locale
          value
        }
      }
    }
  }
`;

export { baseProductFragment };
//# sourceMappingURL=base-product.js.map
